import { render } from "./tablep2h.vue?vue&type=template&id=7ba49e1e"
import script from "./tablep2h.vue?vue&type=script&lang=js"
export * from "./tablep2h.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__